export default __webpack_public_path__ + "static/media/event-location.0edfb567.svg";